import contract from './Transactions.json';

export const contractABI = contract.abi;
export const contractAddress = '0xF311E3F8c8Eb78daE341f63EC3Eb89BB214ACA8f';
